import { extend } from '../../vue';
import { NAME_FORM_RADIO_GROUP } from '../../constants/components';
import { makePropsConfigurable } from '../../utils/props';
import { props as props$1, formRadioCheckGroupMixin } from '../../mixins/form-radio-check-group';

// --- Props ---

const props = makePropsConfigurable(props$1, NAME_FORM_RADIO_GROUP);

// --- Main component ---

// @vue/component
const BFormRadioGroup = /*#__PURE__*/extend({
  name: NAME_FORM_RADIO_GROUP,
  mixins: [formRadioCheckGroupMixin],
  provide() {
    return {
      getBvRadioGroup: () => this
    };
  },
  props,
  computed: {
    isRadioGroup() {
      return true;
    }
  }
});

export { BFormRadioGroup, props };
